import { useSortable } from "@dnd-kit/sortable";
import { SellingItem } from "../../../assets/utils/data/selling";
import { CSS } from "@dnd-kit/utilities";
import { motion } from "framer-motion";
import { LittleSubHeadline, LittleText, NotificationText } from "../../typography";
import { COLORS } from "../../../assets/utils/enums/colors";
import styled from "styled-components";
import { formatDate } from "../../../assets/utils/date-formatter";
import { useNavigate } from "react-router-dom";

export default function LayoutCard({ item }: { item: SellingItem }) {
  return (
    <Card>
      <CardRow>
        <LittleSubHeadline>{item.name}</LittleSubHeadline>
      </CardRow>

      <CardRow>
        <NotificationText>Сума:</NotificationText>{" "}
        <LittleText>{item.amount}</LittleText>
      </CardRow>

      <CardRow>
        <NotificationText>Дедлайн:</NotificationText>{" "}
        <LittleText>{formatDate(item.deadline)}</LittleText>
      </CardRow>

      <CardRow>
        <NotificationText>Замовник:</NotificationText>{" "}
        <LittleText>{item.clientName}</LittleText>
      </CardRow>

      <CardRow>
        <NotificationText>Контакт:</NotificationText>{" "}
        <LittleText>{item.responsibleContact}</LittleText>
      </CardRow>
    </Card>
  )
}

export function SortableCard({ item }: { item: SellingItem }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: `item-${item.id}` });

  const navigate = useNavigate();

  const style: React.CSSProperties = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.12 : 1,
    cursor: "grab",
    touchAction: "manipulation",
  };

  return (
    <motion.div ref={setNodeRef as any} style={style} {...attributes} {...listeners} onClick={(e) => {
      e.stopPropagation(); 
      navigate(`/selling/details/${item.id}`);
    }}>
      <LayoutCard item={item} />
    </motion.div>
  );
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS["light-gray"]};
  border-radius: 4px;
  padding: 12px;
  border: 1px solid ${COLORS["light-bg-color"]};

  ${LittleSubHeadline} {
    padding-bottom: 3px;
  }
`;

// export const MotionCard = motion(Card);

const CardRow = styled.span`
  display: flex;
  align-items: center;
  column-gap: 8px;
  row-gap: 0;
  flex-wrap: wrap;
  ${NotificationText} {
    color: ${COLORS["bg-text-color"]};
  }
  ${LittleSubHeadline} {
    font-size: 15px;
  }
  ${LittleText}, ${LittleSubHeadline} {
    color: ${COLORS.secondary1};
  }
`;